/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { FC } from 'react'
import {
  Card,
  CardBody,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'
import { NumericTextBox } from '@progress/kendo-react-inputs'
import { Label } from '@progress/kendo-react-labels'
import { SimulationCalculationInfoResItem } from '@gateway.Simulation'
export interface ExpenseInformationProps {
  workYamadumi: SimulationCalculationInfoResItem
  isReadonlyDisabled: boolean
  onChange: (id: string, value: number | null) => void
}
export const ExpenseInformationAppropriateTypeB: FC<ExpenseInformationProps> = React.memo(({
  workYamadumi,
  isReadonlyDisabled,
  onChange
}) => {
  return (
    <Card>
      <CardBody>
        <GridLayout gap={{ cols: 10 }}>
          <GridLayoutItem col={3}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>労務数量（{workYamadumi.unit3}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>全体</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityAll ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityAll', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>準備</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityPreparation ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityPreparation', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>基礎・地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityUnderground ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityUnderground', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={5} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={5} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityGround ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityGround', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={6} col={1}>
                <label>仕上げ</label>
              </GridLayoutItem>
              <GridLayoutItem row={6} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityFinish ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityFinish', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={4}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>工期（ヶ月）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>準備</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.schedulePreparation ?? undefined}
                  onChange={
                    (event) => onChange('schedulePreparation', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>基礎・地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleUnderground ?? undefined}
                  onChange={
                    (event) => onChange('scheduleUnderground', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleGround ?? undefined}
                  onChange={
                    (event) => onChange('scheduleGround', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={5} col={1}>
                <label>仕上げ</label>
              </GridLayoutItem>
              <GridLayoutItem row={5} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleFinish ?? undefined}
                  onChange={
                    (event) => onChange('scheduleFinish', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={5}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>予定({workYamadumi.unit7})数（{workYamadumi.unit6}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>準備</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkPreparation ?? undefined}
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>基礎・地下</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkUnderground ?? undefined}
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>地上</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkGround ?? undefined}
                />
              </GridLayoutItem>
              <GridLayoutItem row={5} col={1}>
                <label>仕上げ</label>
              </GridLayoutItem>
              <GridLayoutItem row={5} col={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkFinish ?? undefined}
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
        </GridLayout>
      </CardBody>
    </Card>
  )
})
